<template>
  <div class="box">
    <div class="comments mx-4 my-6">
      <div class="comments__info d-flex align-center">
        <div class="comments__info-icon d-flex">
          <svg viewBox="0 0 326 296" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="183.713" cy="147.591" rx="93.1442" ry="115.167" transform="rotate(34.1224 183.713 147.591)" fill="#F1F1F1"/>
            <rect x="118" y="33" width="172" height="118" rx="11" stroke="#B9B9B9" stroke-width="4"/>
            <circle cx="58" cy="193" r="56" fill="#3B3973" fill-opacity="0.75" stroke="#B9B9B9" stroke-width="4"/>
            <path d="M159.542 75.7871C159.077 75.7871 158.631 75.8579 158.187 75.9225C158.331 75.4392 158.479 74.9475 158.717 74.5059C158.954 73.8642 159.325 73.3079 159.694 72.7475C160.002 72.1413 160.546 71.7309 160.946 71.2121C161.365 70.7079 161.935 70.3725 162.387 69.9538C162.831 69.5163 163.412 69.2975 163.875 68.9892C164.358 68.7121 164.779 68.4059 165.229 68.26L166.352 67.7975L167.34 67.3871L166.329 63.3496L165.085 63.6496C164.687 63.7496 164.202 63.8663 163.65 64.0059C163.085 64.11 162.483 64.3954 161.812 64.6559C161.15 64.9517 160.383 65.1517 159.671 65.6267C158.954 66.0809 158.127 66.46 157.398 67.0684C156.692 67.6954 155.84 68.2392 155.21 69.0371C154.523 69.7829 153.844 70.5663 153.317 71.4579C152.706 72.3079 152.292 73.2413 151.854 74.1642C151.458 75.0871 151.14 76.0309 150.879 76.9475C150.385 78.785 150.165 80.5309 150.079 82.0246C150.008 83.5204 150.05 84.7642 150.137 85.6642C150.169 86.0892 150.227 86.5017 150.269 86.7871L150.321 87.1371L150.375 87.1246C150.745 88.8555 151.598 90.4461 152.835 91.7125C154.072 92.9788 155.642 93.8692 157.364 94.2805C159.085 94.6918 160.888 94.6073 162.564 94.0368C164.24 93.4662 165.72 92.4329 166.832 91.0564C167.945 89.68 168.646 88.0165 168.853 86.2586C169.06 84.5006 168.765 82.7199 168.002 81.1226C167.24 79.5252 166.04 78.1764 164.543 77.2322C163.046 76.288 161.312 75.787 159.542 75.7871ZM182.458 75.7871C181.994 75.7871 181.548 75.8579 181.104 75.9225C181.248 75.4392 181.396 74.9475 181.633 74.5059C181.871 73.8642 182.242 73.3079 182.61 72.7475C182.919 72.1413 183.462 71.7309 183.862 71.2121C184.281 70.7079 184.852 70.3725 185.304 69.9538C185.748 69.5163 186.329 69.2975 186.792 68.9892C187.275 68.7121 187.696 68.4059 188.146 68.26L189.269 67.7975L190.256 67.3871L189.246 63.3496L188.002 63.6496C187.604 63.7496 187.119 63.8663 186.567 64.0059C186.002 64.11 185.4 64.3954 184.729 64.6559C184.069 64.9538 183.3 65.1517 182.587 65.6288C181.871 66.0829 181.044 66.4621 180.315 67.0704C179.608 67.6975 178.756 68.2413 178.127 69.0371C177.44 69.7829 176.76 70.5663 176.233 71.4579C175.623 72.3079 175.208 73.2413 174.771 74.1642C174.375 75.0871 174.056 76.0309 173.796 76.9475C173.302 78.785 173.081 80.5309 172.996 82.0246C172.925 83.5204 172.967 84.7642 173.054 85.6642C173.085 86.0892 173.144 86.5017 173.185 86.7871L173.237 87.1371L173.292 87.1246C173.662 88.8555 174.515 90.4461 175.752 91.7125C176.989 92.9788 178.559 93.8692 180.28 94.2805C182.002 94.6918 183.805 94.6073 185.481 94.0368C187.156 93.4662 188.636 92.4329 189.749 91.0564C190.862 89.68 191.563 88.0165 191.77 86.2586C191.977 84.5006 191.682 82.7199 190.919 81.1226C190.156 79.5252 188.957 78.1764 187.46 77.2322C185.962 76.288 184.228 75.787 182.458 75.7871Z" fill="#B9B9B9"/>
            <rect x="204" y="77.9541" width="60" height="5" rx="2.5" fill="#B9B9B9"/>
            <rect x="204" y="91.9541" width="60" height="5" rx="2.5" fill="#B9B9B9"/>
            <rect x="161" y="104.954" width="103" height="5" rx="2.5" fill="#B9B9B9"/>
            <rect x="33.8284" y="71.7158" width="53.5802" height="53.5802" transform="rotate(-45 33.8284 71.7158)" fill="#FC9861" stroke="#B9B9B9" stroke-width="4"/>
          </svg>

        </div>
        <div class="comments__info-elementInfo">
          <h6 class="text-gray-light">{{ elementType }}</h6>
<!--          TODO: fetch element text-->
          <span class="text-description text-semibold">{{ elementName }}</span>
        </div>
      </div>
      <h5 v-if="description.text">Aktuelle Beschreibung</h5>
      <div v-if="description.text" style="overflow: auto; height:150px" v-html="highlightLinks(description.text)"></div>
      <div style="padding:25px" />
      <v-textarea :disabled="!canEdit" label="Beschreibung des Elements bearbeiten" v-model="description.text"
                  class="comments__description"></v-textarea>
      <v-btn v-if="canEdit" text @click="description.text=''" block color="gray_3" class="mb-2">
        <v-icon>mdi-close-circle</v-icon>Text zurücksetzen
      </v-btn>
    </div>
    <div v-if="canEdit" class="newComment">
      <div>
        <v-btn @click="saveElementDescription" block color="primary" elevation="0">
          Speichern
        </v-btn>
      </div>
    </div>
    <v-snackbar
      :timeout="snackTimeout"
      v-model="snackbar"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import elementDescriptionService from "./element-description-service";
import {decodeElementByName} from "@/components/util";

export default {
  components: {},
  props: {
    uuid: String,
    elementId: String,
    element: Object,
    canEdit: Boolean
  },
  data: function() {
    return {
      description: {
        text:'abc'
      },
      snackbar: false,
      snackTimeout: 2200,
      snackbarText: 'Beschreibung wurde erfolgreich gespeichert!',
    };
  },
  mounted: function() {
    this.retrieveDescription();
  },
  watch: {
    elementId: function(val) {
      this.retrieveDescription();
    }
  },
  computed: {
    elementType(){
      if(!this.element || !this.element.businessObject) return "";
      return this.element.businessObject.$type.split(':')[1];
    },
    elementName(){
      if(!this.element || !this.element.businessObject) return "";
      let regex = /^(.*)_(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])/i;
      var name = this.element.businessObject.name ? this.element.businessObject.name : this.element.id;
      if(regex.test(name)) return "";
      return name;
    }
  },
  methods: {
    decodeElementByName: decodeElementByName,
    saveElementDescription(){
      if(this.description.id != null){
        elementDescriptionService.editDescription(this.description).then(()=>{
          this.retrieveDescription();
          this.$emit("refresh");
        });
      }else{
        elementDescriptionService.saveElementDescription(this.uuid, this.elementId, this.description.text).then(()=>{
          this.retrieveDescription();
          this.$emit("refresh");
        });
      }
      this.snackbar = true;
      
    },
    retrieveDescription(){
      this.description = {
        text: null
      }
      elementDescriptionService.retrieveDescription(this.uuid, this.elementId).then(result =>{
        if(result.data != '' && result.data != null){
          this.description = result.data;
        }
      });
    },
    highlightLinks(text) {
      // Regular expression to match URLs
      const urlRegex = /((http|https):\/\/[^\s]+)/g;

      // Replace URLs with anchor tags
      const highlightedText = text.replace(urlRegex, '<a href="$&" target="_blank">$&</a>');

      return highlightedText;
    },
  }
};
</script>
<style lang="scss" scoped>
.comments,
.newComment {
  position: absolute;
}
.comments {
  top: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
    &__info {
        flex-wrap: wrap;
        &-icon {
            width:40%;
            height: 40%;
            max-height: 150px;
            margin: 0 auto;
        }
        &-elementInfo {
            width: 60%;
        }
    }
}
:deep .comments__description .v-text-field__slot {
    label {
        top: 10px;
        left: 10px;
        padding-left: 10px;
    }
    textarea {
        background-color: var(--background-shade) !important;
        border-radius: 10px 10px 0 0;
        padding: 10px 10px 10px 10px;
        height: calc(100vh - 368px - 32px - 50px - 200px);
    }
}
.newComment {
  bottom: 0;
  right: 0;
  left: 0;
  margin:10px
}
.box {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}
.sub {
  font-size: 0.7rem;
}
</style>